import { AssetRef, MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  reducerActions,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "block_videos"

export type BlockVideo = {
  kind: typeof kind
  version: number
  type: "video"
  assets: Array<AssetRef>
  transcript_id: string
  autoPlay?: boolean
  showCaptions?: boolean
  videoTitle: string
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockVideo, MetaType>("meta", kind),
  assets: actionCreatorGuard<BlockVideo, Array<AssetRef>>("assets", kind),
  transcript_id: actionCreatorGuard<BlockVideo, string>("transcript_id", kind),
  autoPlay: actionCreatorGuard<BlockVideo, boolean>("autoPlay", kind),
  showCaptions: actionCreatorGuard<BlockVideo, boolean>("showCaptions", kind),
  videoTitle: actionCreatorGuard<BlockVideo, string>("videoTitle", kind),
  type: actionCreatorGuard<BlockVideo, string>("type", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockVideo,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockVideoAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockVideoReducer = reducerGuard<BlockVideo>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  .case(...reducerAction.transcript_id)
  .case(...reducerAction.autoPlay)
  .case(...reducerAction.showCaptions)
  .case(...reducerAction.videoTitle)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<BlockVideo, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )
    }

    return prevState
  })
